import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { InventoryService } from './inventory.service';


declare var Quagga:any;

@Component({
  selector: 'app-scanview',
  templateUrl: './scanview.component.html',
  styleUrls: ['./scanview.component.css']
})
export class ScanviewComponent implements OnInit {

  result:string;

  constructor(
    private _ref: ChangeDetectorRef,
    private _invService: InventoryService
  ) {
    Quagga.onDetected((res) => this.onDetected(res));
  }

  ngOnInit() {

  }

  startScanner() {

    Quagga.init({
      inputStream : {
        name : "Live",
        type : "LiveStream",
        target: document.querySelector('#scanner-target'),
        constraints: {
          width: document.getElementById("target-parent").offsetWidth,
          height: 480,
        },
      },
      decoder : {
        readers : ["code_128_reader"]
      },
      locate: true
    }, function(err) {
      if (err) {
        console.log(err);
        return
      }
      console.log("Initialization finished. Ready to start");
      Quagga.start();
    });
  }

  onDetected(res) {
      if(res) {
        Quagga.stop();
        this.result = res.codeResult.code;
        this._ref.detectChanges();
        //this._invService.setBarCode(res.codeResult.code);
      }
  }


  searchResult() {
    this._invService.setBarCode(this.result);
  }

  stopScanner() {
    Quagga.stop();
  }

  close() {
    this._invService.setShowScan(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/scanview.component.ts